import { useEffect, useState } from "react";
import carousel1 from "../assets/img/crausel.png";
import carousel2 from "../assets/img/crausei1.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEmail } from "../hooks/useEmail";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import aboutImg from "../assets/img/ab.jpg"; // replace with correct path
import { faTimes, faUsers, faLightbulb, faCheck, faBars, faArrowRight, faLink, faQuoteRight } from "@fortawesome/free-solid-svg-icons";
import { faFacebookF, faTwitter, faInstagram, } from "@fortawesome/free-brands-svg-icons";
import service1 from '../assets/img/meeting2.jpg'
import service2 from '../assets/img/meeting3.jpg'
import service3 from '../assets/img/meeting4.jpg'
import service4 from '../assets/img/meeting5.jpg'

import bgImage from '../assets/img/bg.png'
import t1 from '../assets/img/image.jpeg'
import t2 from '../assets/img/image2.jpeg'
import t3 from '../assets/img/image5.jpeg'
import t4 from '../assets/img/image3.jpeg'
import founderImg from '../assets/img/meeting.jpg'
import { Link } from "react-router-dom";
import Fact from '../components/Facts'
import { motion } from "framer-motion";
import retirment from '../assets/img/retirment.jpg'
import retirment1 from '../assets/img/retirment1.jpg'
import retirment2 from '../assets/img/retirment2.jpg'
import study from '../assets/img/study.jpg'
import study1 from '../assets/img/study1.jpg'
import study2 from '../assets/img/study2.jpg'
import FINANCIAL from '../assets/img/FINANCIAL.jpg'
import FINANCIAL1 from '../assets/img/FINANCIAL1.jpg'
import FINANCIAL2 from '../assets/img/FINANCIAL2.jpg'
const Home = () => {
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) entry.target.classList.add("fade-in");
                });
            },
            { threshold: 0.1 }
        );

        document.querySelectorAll(".fade-on-scroll").forEach((el) => observer.observe(el));
    }, []);

    const { sendEmail, isSending } = useEmail();
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        mobile: "",
        subjects: "",
        message: "",
    });

    // update state on input change
    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData((prev) => ({ ...prev, [id]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const { name, email, phone, city, topic, message, subjects } = formData;

        const emailMsg = `
        Name: ${name}
        Email: ${email}
        Phone: ${phone}
        City & State: ${city}
        Topic: ${topic}
        Message: ${message}
      `;

        const subject = `Request A Call-Back - ${subjects}`;
        try {
            await sendEmail(emailMsg, subject);

            setFormData({
                name: "",
                email: "",
                phone: "",
                city: "",
                topic: "",
                message: "",
            });
        } catch (err) {

            console.error(err);
        }
    };





    const responsive = {
        superLargeDesktop: { breakpoint: { max: 4000, min: 1200 }, items: 3 },
        desktop: { breakpoint: { max: 1200, min: 992 }, items: 2 },
        tablet: { breakpoint: { max: 992, min: 576 }, items: 1 },
        mobile: { breakpoint: { max: 576, min: 0 }, items: 1 },
    };

    const projects = [
        { img: service1, title: "Wealth & Goal Planning" },
        { img: service2, title: "Investment Solutions" },
        { img: service3, title: "Protection Planning" },
        { img: service4, title: "Tax Planning & Loan Advisory" },
    ];

 

    const testimonials = [
        {
            img: t1,
            text: "Dolores sed duo clita tempor justo dolor et stet lorem kasd labore dolore lorem ipsum. At lorem lorem magna ut et, nonumy et labore et tempor diam tempor erat.",
            name: "Ansh Sharma",
            role: "Financial Advisor",
        },
        {
            img: t2,
            text: "At lorem lorem magna ut et, nonumy et labore et tempor diam tempor erat. Dolores sed duo clita tempor justo dolor et stet lorem kasd labore dolore lorem ipsum.",
            name: "Rohit Verma",
            role: "Business Owner",
        },
        {
            img: t3,
            text: "Nonumy et labore et tempor diam tempor erat. Dolores sed duo clita tempor justo dolor et stet lorem kasd labore dolore lorem ipsum. At lorem lorem magna ut et.",
            name: "Neha Gupta",
            role: "Investor",
        },
        {
            img: t4,
            text: "Stet lorem kasd labore dolore lorem ipsum. At lorem lorem magna ut et, nonumy et labore et tempor diam tempor erat. Dolores sed duo clita tempor justo dolor et.",
            name: "Amit Patel",
            role: "Entrepreneur",
        },
    ];
    const [activeTab, setActiveTab] = useState("tab1");

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };
    return (
        <div className="container-fluid p-0 mb-5">
            <div
                id="header-carousel"
                className="carousel slide carousel-fade"
                data-bs-ride="carousel"
            >
                <div className="carousel-inner">
                    {/* Slide 1 */}
                    <div className="carousel-item active position-relative">
                        <img className="w-100" src={carousel1} alt="Financial Growth" />
                        <div className="carousel-caption text-start">
                            <div className="container">
                                <div className="col-lg-8 col-md-10">
                                    <p className=" d-inline-block welcome border border-white rounded  fw-bold py-1 px-3 animated slideInDown"
                                        style={{ color: "var(--primary)", fontSize: "22px" }}>
                                        Welcome to SAG Financials
                                    </p>

                                    <h1 className="display-6 fw-semi-bold mb-3 animated slideInDown text-shadow"
                                        style={{ color: "var(--secondary)" }}>
                                        Your Financial Status Is Our Goal
                                    </h1>
                                    <Link
                                        to="/industriesweserve"
                                        className="btn  py-3 px-5 animated slideInDown"
                                        style={{ backgroundColor: "var(--primary)", borderColor: "var(--primary)", color: "#fff" }}
                                    >
                                        Explore More{" "}
                                        <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Slide 2 */}
                    <div className="carousel-item position-relative">
                        <img className="w-100" src={carousel2} alt="Financial Planning" />
                        <div className="carousel-caption text-start">
                            <div className="container">
                                <div className="col-lg-7 col-md-10">
                                    <p className=" d-inline-block border welcome border-white rounded  fw-bold py-1 px-3 animated slideInDown"
                                        style={{ color: "var(--primary)", fontSize: "22px" }}>
                                        Welcome to SAG Financials
                                    </p>
                                    <h1 className="display-6  fw-semi-bold mb-3 animated slideInDown  text-shadow"
                                        style={{ color: "var(--secondary)" }}>
                                        True Financial Support For You
                                    </h1>
                                    <Link
                                        to="/services"
                                        className="btn py-3 px-5 animated slideInDown"
                                        style={{ backgroundColor: "var(--primary)", borderColor: "var(--primary)", color: "#fff" }}

                                    >
                                        Learn More{" "}
                                        <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <button class="carousel-control-prev" type="button" data-bs-target="#header-carousel" data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                </button>
                <button class="carousel-control-next" type="button" data-bs-target="#header-carousel" data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                </button>
            </div>
            <section className="container-xxl about-section " style={{ backgroundColor: "var(--light-bg)" }}>
                <div className="container py-5">
                    <div className="row align-items-center g-5">
                        {/* Left Image */}
                        <div className="col-lg-5 text-center">
                            <motion.img
                                src={founderImg}
                                alt="Shepra Anand"
                                className="img-fluid rounded shadow-lg founder-img"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.8 }}
                                style={{
                                    border: "5px solid var(--secondary)",
                                    borderRadius: "1rem",
                                    height: '500px'
                                }}
                            />
                        </div>

                        {/* Right Text */}
                        <div className="col-lg-7">
                            <motion.div
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.8, delay: 0.3 }}
                                style={{ color: "var(--dark)" }}
                            >
                                <p
                                    className="d-inline-block border rounded fw-semi-bold py-1 px-3 mb-3"
                                    style={{
                                        color: "var(--primary)",
                                        borderColor: "var(--primary)",
                                        backgroundColor: "var(--white)",
                                    }}
                                >
                                    Welcome to SAG Financials
                                </p>

                                <h1
                                    className="display-6 mb-4"
                                    style={{
                                        color: "var(--heading)",
                                        fontWeight: "700",
                                    }}
                                >
                                    Your Partner in Wealth Creation, Protection & Financial Well-Being
                                </h1>

                                <p
                                    className="lead mb-4"
                                    style={{
                                        color: "var(--highlight)",
                                        fontSize: "1.05rem",
                                    }}
                                >
                                    At SAG Financials, we help individuals and families achieve their
                                    financial goals through transparent, digital-first, and personalized
                                    financial planning.
                                </p>

                                <p className="mb-4" style={{ color: "var(--text)" }}>
                                    <strong>Founded in 2017</strong>, our mission is simple — to simplify
                                    finance and empower you to build long-term wealth, protection, and
                                    security with trust, clarity, and expert guidance.
                                </p>

                                <motion.div
                                    className="border rounded p-4 shadow-sm"
                                    initial={{ opacity: 0, sccd: 0.9 }}
                                    whileInView={{ opacity: 1, scale: 1 }}
                                    transition={{ duration: 0.6, delay: 0.5 }}
                                    style={{
                                        backgroundColor: "var(--white)",
                                        borderColor: "var(--secondary)",
                                    }}
                                >
                                    <h4
                                        className="mb-3"
                                        style={{
                                            color: "var(--primary)",
                                            fontWeight: "600",
                                        }}
                                    >
                                        Trusted Financial Advice Backed by 22+ Years of Experience
                                    </h4>

                                    <p className="mb-3" style={{ color: "var(--text)" }}>
                                        Led by <strong>Shepra Anand</strong>, Founder & CEO, SAG Financials brings
                                        over 22 years of rich experience in the financial services industry. Our
                                        journey started with some of India’s most respected institutions:
                                    </p>

                                    <ul className="mb-0 list-unstyled" style={{ color: "var(--dark)" }}>
                                        <li>• ICICI Bank</li>
                                        <li>• IDBI Federal Life Insurance</li>
                                        <li>• Aditya Birla Sun Life</li>
                                        <li>• Religare Broking</li>
                                    </ul>
                                </motion.div>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>

            <div
                className="container-xxl py-5"
                style={{ backgroundColor: "var(--light-bg)" }}
            >
                <div className="container">
                    {/* ==================== TOP ROW ==================== */}
                    <div className="row g-4 align-items-end mb-4">
                        {/* Left Image */}
                        <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                            <img
                                className="img-fluid rounded shadow-lg"
                                src={aboutImg}
                                alt="About Us"
                                style={{
                                    border: "5px solid var(--secondary)",
                                    borderRadius: "1rem",
                                    height: '500px'
                                }}
                            />
                        </div>

                        {/* Right Text */}
                        <div
                            className="col-lg-6 wow fadeInUp"
                            data-wow-delay="0.3s"
                            style={{ color: "var(--dark)" }}
                        >
                            <p
                                className="d-inline-block border rounded fw-semi-bold py-1 px-3"
                                style={{
                                    color: "var(--primary)",
                                    borderColor: "var(--primary)",
                                    backgroundColor: "var(--white)",
                                }}
                            >
                                About Us
                            </p>

                            <h1
                                className="display-5 mb-4"
                                style={{
                                    color: "var(--heading)",
                                    fontWeight: "700",
                                }}
                            >
                                We Help Our Clients To Grow Their Business
                            </h1>

                            <p className="mb-4" style={{ color: "var(--text)" }}>
                                SAG Financials works with clients at every stage of their financial
                                journey. We assist working professionals planning for the future,
                                families focused on education and protection, retirees seeking secure
                                income options, and entrepreneurs needing structured financial plans.
                                Whether you’re just starting out or looking to rebalance your
                                investments, we’re here to provide guidance and support every step of
                                the way.
                            </p>

                            {/* ==================== TABS ==================== */}
                            <div
                                className="border rounded p-4 shadow-sm"
                                style={{
                                    borderColor: "var(--secondary)",
                                    backgroundColor: "var(--white)",
                                }}
                            >
                                <nav>
                                    <div className="nav nav-tabs mb-3" id="nav-tab" role="tablist">
                                        {["Story", "Mission", "Vision"].map((tab, i) => (
                                            <button
                                                key={i}
                                                className={`nav-link fw-semi-bold ${i === 0 ? "active" : ""}`}
                                                id={`nav-${tab.toLowerCase()}-tab`}
                                                data-bs-toggle="tab"
                                                data-bs-target={`#nav-${tab.toLowerCase()}`}
                                                type="button"
                                                role="tab"
                                                aria-controls={`nav-${tab.toLowerCase()}`}
                                                aria-selected={i === 0 ? "true" : "false"}
                                                style={{
                                                    color: i === 0 ? "var(--primary)" : "var(--dark)",
                                                    backgroundColor:
                                                        i === 0 ? "var(--white)" : "transparent",
                                                    border: "none",
                                                    borderBottom:
                                                        i === 0
                                                            ? "2px solid var(--primary)"
                                                            : "2px solid transparent",
                                                    padding: "10px 18px",
                                                    transition: "all 0.3s ease",
                                                }}
                                                onMouseEnter={(e) => {
                                                    if (!e.currentTarget.classList.contains("active")) {
                                                        e.currentTarget.style.color = "var(--primary)";
                                                        e.currentTarget.style.borderBottom =
                                                            "2px solid var(--secondary)";
                                                    }
                                                }}
                                                onMouseLeave={(e) => {
                                                    if (!e.currentTarget.classList.contains("active")) {
                                                        e.currentTarget.style.color = "var(--dark)";
                                                        e.currentTarget.style.borderBottom =
                                                            "2px solid transparent";
                                                    }
                                                }}
                                                onClick={(e) => {
                                                    const tabs =
                                                        e.currentTarget.parentElement.querySelectorAll(".nav-link");
                                                    tabs.forEach((btn) => {
                                                        btn.style.color = "var(--dark)";
                                                        btn.style.borderBottom = "2px solid transparent";
                                                        btn.style.backgroundColor = "transparent";
                                                    });
                                                    e.currentTarget.style.color = "var(--primary)";
                                                    e.currentTarget.style.borderBottom =
                                                        "2px solid var(--primary)";
                                                    e.currentTarget.style.backgroundColor = "var(--white)";
                                                }}
                                            >
                                                {tab}
                                            </button>
                                        ))}
                                    </div>
                                </nav>

                                {/* TAB CONTENT */}
                                <div
                                    className="tab-content"
                                    id="nav-tabContent"
                                    style={{ color: "var(--text)" }}
                                >
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-story"
                                        role="tabpanel"
                                        aria-labelledby="nav-story-tab"
                                    >
                                        <p>
                                            SAG Financials was founded in 2017 by{" "}
                                            <strong>Shepra Anand</strong>, who spent over 20 years in top
                                            financial institutions. Seeing how many people struggled with
                                            confusing financial products, she created SAG Financials to
                                            focus on serving clients, not selling products. Since then, the
                                            company has helped hundreds plan smarter, live securely, and
                                            make informed financial decisions.
                                        </p>
                                    </div>

                                    <div
                                        className="tab-pane fade"
                                        id="nav-mission"
                                        role="tabpanel"
                                        aria-labelledby="nav-mission-tab"
                                    >
                                        <p>
                                            <strong>Our Mission:</strong> At SAG Financials, our mission is
                                            to empower individuals to make smarter financial decisions with
                                            confidence. We simplify complex financial concepts, provide
                                            personalized guidance, and ensure every client’s plan aligns
                                            with their real needs. By putting people before products, we
                                            help build a secure and informed financial future for all.
                                        </p>
                                    </div>

                                    <div
                                        className="tab-pane fade"
                                        id="nav-vision"
                                        role="tabpanel"
                                        aria-labelledby="nav-vision-tab"
                                    >
                                        <p>
                                            To empower people with financial clarity and help them achieve life goals
                                            confidently through proper planning, disciplined investing, and transparent
                                            guidance.
                                            I’m committed to making financial planning simple, accessible, and meaningful
                                            for every individual and family I work with.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ==================== BOTTOM FEATURES ==================== */}
                    <div
                        className="border rounded p-4 wow fadeInUp mt-5"
                        data-wow-delay="0.1s"
                        style={{
                            borderColor: "var(--secondary)",
                            backgroundColor: "var(--white)",
                            color: "var(--dark)",
                        }}
                    >
                        <div className="row g-4">
                            {[
                                {
                                    icon: faTimes,
                                    title: " Full Transparency",
                                    text: "Transparent pricing for all clients.",
                                },
                                {
                                    icon: faUsers,
                                    title: "Dedicated Team",
                                    text: "Our experts work with you personally.",
                                },
                                {
                                    icon: faLightbulb,
                                    title: "Creative Solutions",
                                    text: "We bring fresh ideas to every project.",
                                }
                            ].map((item, i) => (
                                <div
                                    className="col-lg-4 wow fadeIn"
                                    data-wow-delay={`${0.1 + i * 0.2}s`}
                                    key={i}
                                >
                                    <div className="h-100">
                                        <div className="d-flex align-items-start">
                                            <div
                                                className="flex-shrink-0 btn-lg-square rounded-circle d-flex align-items-center justify-content-center"
                                                style={{
                                                    backgroundColor: "var(--primary)",
                                                    width: "60px",
                                                    height: "60px",
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    icon={item.icon}
                                                    style={{ color: "var(--white)", fontSize: "1.2rem" }}
                                                />
                                            </div>
                                            <div className="ps-3">
                                                <h4
                                                    style={{
                                                        color: "var(--heading)",
                                                        fontWeight: "600",
                                                    }}
                                                >
                                                    {item.title}
                                                </h4>
                                                <span style={{ color: "var(--text)" }}>{item.text}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            {/* <Fact /> */}

            <section
                className="container-xxl feature py-5"
                style={{ backgroundColor: "var(--light-bg)" }}
            >
                <div className="container">
                    <div className="row g-5 align-items-center">
                        {/* ===== Left Section ===== */}
                        <div
                            className="col-lg-6"
                            data-wow-delay="0.1s"
                            style={{ animation: "fadeInUp 0.8s ease" }}
                        >
                            <p
                                className="d-inline-block border rounded fw-semi-bold py-1 px-3"
                                style={{
                                    color: "var(--primary)",
                                    borderColor: "var(--primary)",
                                    backgroundColor: "var(--white)",
                                }}
                            >
                                Why Choose SAG Financials?
                            </p>

                            <h1
                                className="display-5 mb-4"
                                style={{
                                    color: "var(--heading)",
                                    fontWeight: "700",
                                }}
                            >
                                Few Reasons Why People Choosing Us!
                            </h1>

                            <p className="mb-4" style={{ color: "var(--text)" }}>
                                We’re not just advisors — we’re your partners in achieving financial freedom.
                                Here’s why hundreds of clients trust us:
                            </p>

                            <Link
                                className="btn py-3 px-5"
                                to="/services"
                                style={{
                                    backgroundColor: "var(--primary)",
                                    color: "var(--white)",
                                    border: "none",
                                    borderRadius: "6px",
                                    fontWeight: "500",
                                    transition: "all 0.3s ease",
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = "var(--secondary)";
                                    e.currentTarget.style.color = "var(--dark)";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = "var(--primary)";
                                    e.currentTarget.style.color = "var(--white)";
                                }}
                            >
                                Explore More
                            </Link>
                        </div>

                        {/* ===== Right Section ===== */}
                        <div className="col-lg-6">
                            <div className="row g-4 align-items-center">
                                {/* Left column (2 boxes) */}
                                <div className="col-md-6">
                                    <div className="row g-4">
                                        {[
                                            {
                                                title: "Fast Executions",
                                                text:
                                                    "22+ Years of Expertise — Decades of proven experience across wealth management, insurance, and tax planning.",
                                                delay: "0.3s",
                                            },
                                            {
                                                title: "Certified & Recognized",
                                                text:
                                                    "We’re AMFI, IRDA, and NISM certified. Our advisory meets the highest professional and ethical standards.",
                                                delay: "0.5s",
                                            },
                                        ].map((item, i) => (
                                            <div
                                                className="col-12"
                                                key={i}
                                                data-wow-delay={item.delay}
                                                style={{ animation: "fadeInUp 0.8s ease" }}
                                            >
                                                <div
                                                    className="feature-box border rounded p-4 h-100 shadow-sm"
                                                    style={{
                                                        borderColor: "var(--secondary)",

                                                        transition: "transform 0.4s ease, box-shadow 0.4s ease",
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.transform = "translateY(-6px)";
                                                        e.currentTarget.style.boxShadow =
                                                            "0 8px 20px rgba(0,0,0,0.15)";
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.transform = "translateY(0)";
                                                        e.currentTarget.style.boxShadow = "RED";
                                                    }}
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faCheck}
                                                        className="mb-3"
                                                        style={{
                                                            color: "var(--primary)",
                                                            fontSize: "2.5rem",
                                                            transition: "transform 0.3s ease",
                                                        }}
                                                        onMouseEnter={(e) =>
                                                            (e.currentTarget.style.animation = "pulse 0.8s infinite")
                                                        }
                                                        onMouseLeave={(e) =>
                                                            (e.currentTarget.style.animation = "none")
                                                        }
                                                    />
                                                    <h4
                                                        className="mb-3"
                                                        style={{ color: "var(--heading)", fontWeight: "600" }}
                                                    >
                                                        {item.title}
                                                    </h4>
                                                    <p className="mb-3" style={{ color: "var(--text)" }}>
                                                        {item.text}
                                                    </p>
                                                    <a
                                                        href="#"
                                                        className="fw-semi-bold"
                                                        style={{
                                                            color: "var(--primary)",
                                                            textDecoration: "none",
                                                            transition: "color 0.3s ease",
                                                        }}
                                                        onMouseEnter={(e) =>
                                                            (e.currentTarget.style.color = "var(--secondary)")
                                                        }
                                                        onMouseLeave={(e) =>
                                                            (e.currentTarget.style.color = "var(--primary)")
                                                        }
                                                    >
                                                        Read More{" "}
                                                        <FontAwesomeIcon
                                                            icon={faArrowRight}
                                                            style={{ marginLeft: "5px" }}
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Right Column (Single Box) */}
                                <div
                                    className="col-md-6"
                                    data-wow-delay="0.7s"
                                    style={{ animation: "fadeInUp 0.8s ease" }}
                                >
                                    <div
                                        className="feature-box border rounded p-4 h-100 shadow-sm"
                                        style={{
                                            borderColor: "var(--secondary)",

                                            transition: "transform 0.4s ease, box-shadow 0.4s ease",
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = "translateY(-6px)";
                                            e.currentTarget.style.boxShadow =
                                                "0 8px 20px rgba(0,0,0,0.15)";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = "translateY(0)";
                                            e.currentTarget.style.boxShadow = "none";
                                        }}
                                    >
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="mb-3"
                                            style={{
                                                color: "var(--primary)",
                                                fontSize: "2.5rem",
                                                transition: "transform 0.3s ease",
                                            }}
                                            onMouseEnter={(e) =>
                                                (e.currentTarget.style.animation = "pulse 0.8s infinite")
                                            }
                                            onMouseLeave={(e) =>
                                                (e.currentTarget.style.animation = "none")
                                            }
                                        />
                                        <h4
                                            className="mb-3"
                                            style={{ color: "var(--heading)", fontWeight: "600" }}
                                        >
                                            MDRT Achievements
                                        </h4>
                                        <p className="mb-3" style={{ color: "var(--text)" }}>
                                            Honored with Million Dollar Round Table (MDRT) recognition —
                                            awarded to top global financial professionals.
                                        </p>
                                        <a
                                            href="#"
                                            className="fw-semi-bold"
                                            style={{
                                                color: "var(--primary)",
                                                textDecoration: "none",
                                                transition: "color 0.3s ease",
                                            }}
                                            onMouseEnter={(e) =>
                                                (e.currentTarget.style.color = "var(--secondary)")
                                            }
                                            onMouseLeave={(e) =>
                                                (e.currentTarget.style.color = "var(--primary)")
                                            }
                                        >
                                            Read More{" "}
                                            <FontAwesomeIcon
                                                icon={faArrowRight}
                                                style={{ marginLeft: "5px" }}
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section
                className="container-xxl service py-5"
                style={{ backgroundColor: "var(--light-bg)" }}
            >
                <div className="container">
                    {/* Section Header */}
                    <div
                        className="text-center mx-auto"
                        style={{ maxWidth: "600px" }}
                    >
                        <p
                            className="d-inline-block border rounded fw-semi-bold py-1 px-3"
                            style={{
                                color: "var(--primary)",
                                borderColor: "var(--primary)",
                                backgroundColor: "var(--white)",
                            }}
                        >
                            Our Services
                        </p>
                        <h1
                            className="display-5 mb-5"
                            style={{
                                color: "var(--heading)",
                                fontWeight: "700",
                            }}
                        >
                            Awesome Financial Services For Your Growth
                        </h1>
                    </div>

                    <div className="row g-4">
                        {/* Left Nav */}
                        <div className="col-lg-4">
                            <div className="nav flex-column nav-pills d-flex justify-content-between w-100 h-100 me-4">
                                {[
                                    { id: "tab1", title: "Wealth & Goal Planning" },
                                    { id: "tab2", title: "Investment Solutions" },
                                    { id: "tab3", title: "Protection Planning" },
                                    { id: "tab4", title: "Tax Planning & Loan Advisory" },
                                ].map((tab) => (
                                    <button
                                        key={tab.id}
                                        className={`nav-link w-100 d-flex align-items-center text-start border p-3 mb-3 ${activeTab === tab.id ? "active" : ""
                                            }`}
                                        type="button"
                                        onClick={() => handleTabChange(tab.id)}
                                        style={{
                                            backgroundColor:
                                                activeTab === tab.id ? "var(--primary)" : "var(--white)",
                                            color:
                                                activeTab === tab.id ? "var(--white)" : "var(--dark)",
                                            borderColor: "var(--secondary)",
                                            fontWeight: "500",
                                            borderRadius: "6px",
                                            transition: "all 0.3s ease",
                                        }}
                                    >
                                        <h5 className="m-0">
                                            <FontAwesomeIcon
                                                icon={faBars}
                                                style={{
                                                    color:
                                                        activeTab === tab.id
                                                            ? "var(--white)"
                                                            : "var(--primary)",
                                                    marginRight: "12px",
                                                }}
                                            />
                                            {tab.title}
                                        </h5>
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* Right Content */}
                        <div className="col-lg-8">
                            <div className="tab-content w-100">
                                {/* Tab 1 */}
                                {activeTab === "tab1" && (
                                    <div className="tab-pane fade show active">
                                        <div className="row g-4">
                                            <div className="col-md-6" style={{ minHeight: "350px" }}>
                                                <div className="position-relative h-100">
                                                    <img
                                                        className="position-absolute rounded w-100 h-100"
                                                        src={service3}
                                                        alt="Wealth & Goal Planning"
                                                        style={{
                                                            objectFit: "cover",
                                                            border: "4px solid var(--secondary)",
                                                            borderRadius: "1rem",
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div
                                                className="col-md-6"
                                                style={{ color: "var(--text)" }}
                                            >
                                                <h3
                                                    className="mb-4"
                                                    style={{ color: "var(--heading)", fontWeight: "600" }}
                                                >
                                                    22 Years Of Expertise In Financial Planning
                                                </h3>
                                                <p className="mb-4">
                                                    Helping clients set and achieve their wealth and life
                                                    goals with personalized planning, clarity, and
                                                    confidence.
                                                </p>
                                                <p>
                                                    <FontAwesomeIcon
                                                        icon={faCheck}
                                                        style={{
                                                            color: "var(--primary)",
                                                            marginRight: "10px",
                                                        }}
                                                    />
                                                    Retirement Planning
                                                </p>
                                                <p>
                                                    <FontAwesomeIcon
                                                        icon={faCheck}
                                                        style={{
                                                            color: "var(--primary)",
                                                            marginRight: "10px",
                                                        }}
                                                    />
                                                    Education & Child Planning
                                                </p>
                                                <p>
                                                    <FontAwesomeIcon
                                                        icon={faCheck}
                                                        style={{
                                                            color: "var(--primary)",
                                                            marginRight: "10px",
                                                        }}
                                                    />
                                                    Goal-Based Wealth Management
                                                </p>

                                                <Link
                                                    className="btn py-2 px-4 mt-3"
                                                    to="/services"
                                                    style={{
                                                        backgroundColor: "var(--primary)",
                                                        color: "var(--white)",
                                                        border: "none",
                                                        borderRadius: "6px",
                                                        fontWeight: "500",
                                                        transition: "all 0.3s ease",
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                            "var(--secondary)";
                                                        e.currentTarget.style.color = "var(--dark)";
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                            "var(--primary)";
                                                        e.currentTarget.style.color = "var(--white)";
                                                    }}
                                                >
                                                    Learn More
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Tab 2 */}
                                {activeTab === "tab2" && (
                                    <div className="tab-pane fade show active">
                                        <div className="row g-4">
                                            <div className="col-md-6" style={{ minHeight: "350px" }}>
                                                <div className="position-relative h-100">
                                                    <img
                                                        className="position-absolute rounded w-100 h-100"
                                                        src={service2}
                                                        alt="Investment Solutions"
                                                        style={{
                                                            objectFit: "cover",
                                                            border: "4px solid var(--secondary)",
                                                            borderRadius: "1rem",
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6" style={{ color: "var(--text)" }}>
                                                <h3
                                                    className="mb-4"
                                                    style={{ color: "var(--heading)", fontWeight: "600" }}
                                                >
                                                    22 Years Of Expertise In Investment Solutions
                                                </h3>
                                                <p className="mb-4">
                                                    Customized investment strategies designed to maximize
                                                    returns and minimize risk for all life stages.
                                                </p>
                                                <p>
                                                    <FontAwesomeIcon
                                                        icon={faCheck}
                                                        style={{
                                                            color: "var(--primary)",
                                                            marginRight: "10px",
                                                        }}
                                                    />
                                                    Mutual Funds & SIPs
                                                </p>
                                                <p>
                                                    <FontAwesomeIcon
                                                        icon={faCheck}
                                                        style={{
                                                            color: "var(--primary)",
                                                            marginRight: "10px",
                                                        }}
                                                    />
                                                    Portfolio Management
                                                </p>
                                                <p>
                                                    <FontAwesomeIcon
                                                        icon={faCheck}
                                                        style={{
                                                            color: "var(--primary)",
                                                            marginRight: "10px",
                                                        }}
                                                    />
                                                    Retirement & Tax-Saving Plans
                                                </p>
                                                <Link
                                                    className="btn py-2 px-4 mt-3"
                                                    to="/services"
                                                    style={{
                                                        backgroundColor: "var(--primary)",
                                                        color: "var(--white)",
                                                        border: "none",
                                                        borderRadius: "6px",
                                                        fontWeight: "500",
                                                        transition: "all 0.3s ease",
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                            "var(--secondary)";
                                                        e.currentTarget.style.color = "var(--dark)";
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                            "var(--primary)";
                                                        e.currentTarget.style.color = "var(--white)";
                                                    }}
                                                >
                                                    Learn More
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Tab 3 */}
                                {activeTab === "tab3" && (
                                    <div className="tab-pane fade show active">
                                        <div className="row g-4">
                                            <div className="col-md-6" style={{ minHeight: "350px" }}>
                                                <div className="position-relative h-100">
                                                    <img
                                                        className="position-absolute rounded w-100 h-100"
                                                        src={service3}
                                                        alt="Protection Planning"
                                                        style={{
                                                            objectFit: "cover",
                                                            border: "4px solid var(--secondary)",
                                                            borderRadius: "1rem",
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6" style={{ color: "var(--text)" }}>
                                                <h3
                                                    className="mb-4"
                                                    style={{ color: "var(--heading)", fontWeight: "600" }}
                                                >
                                                    22 Years Of Expertise In Protection Planning
                                                </h3>
                                                <p className="mb-4">
                                                    Ensuring you and your family are financially secure with
                                                    appropriate protection and insurance plans.
                                                </p>
                                                <p>
                                                    <FontAwesomeIcon
                                                        icon={faCheck}
                                                        style={{
                                                            color: "var(--primary)",
                                                            marginRight: "10px",
                                                        }}
                                                    />
                                                    Life & Health Insurance
                                                </p>
                                                <p>
                                                    <FontAwesomeIcon
                                                        icon={faCheck}
                                                        style={{
                                                            color: "var(--primary)",
                                                            marginRight: "10px",
                                                        }}
                                                    />
                                                    Critical Illness Coverage
                                                </p>
                                                <p>
                                                    <FontAwesomeIcon
                                                        icon={faCheck}
                                                        style={{
                                                            color: "var(--primary)",
                                                            marginRight: "10px",
                                                        }}
                                                    />
                                                    Family & Income Protection
                                                </p>
                                                <Link
                                                    className="btn py-2 px-4 mt-3"
                                                    to="/services"
                                                    style={{
                                                        backgroundColor: "var(--primary)",
                                                        color: "var(--white)",
                                                        border: "none",
                                                        borderRadius: "6px",
                                                        fontWeight: "500",
                                                        transition: "all 0.3s ease",
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                            "var(--secondary)";
                                                        e.currentTarget.style.color = "var(--dark)";
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                            "var(--primary)";
                                                        e.currentTarget.style.color = "var(--white)";
                                                    }}
                                                >
                                                    Learn More
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Tab 4 */}
                                {activeTab === "tab4" && (
                                    <div className="tab-pane fade show active">
                                        <div className="row g-4">
                                            <div className="col-md-6" style={{ minHeight: "350px" }}>
                                                <div className="position-relative h-100">
                                                    <img
                                                        className="position-absolute rounded w-100 h-100"
                                                        src={service4}
                                                        alt="Tax Planning & Loan Advisory"
                                                        style={{
                                                            objectFit: "cover",
                                                            border: "4px solid var(--secondary)",
                                                            borderRadius: "1rem",
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6" style={{ color: "var(--text)" }}>
                                                <h3
                                                    className="mb-4"
                                                    style={{ color: "var(--heading)", fontWeight: "600" }}
                                                >
                                                    22 Years Of Expertise In Tax & Loan Advisory
                                                </h3>
                                                <p className="mb-4">
                                                    Optimized tax planning and loan solutions tailored for
                                                    businesses and individuals.
                                                </p>
                                                <p>
                                                    <FontAwesomeIcon
                                                        icon={faCheck}
                                                        style={{
                                                            color: "var(--primary)",
                                                            marginRight: "10px",
                                                        }}
                                                    />
                                                    Tax Planning & Filing
                                                </p>
                                                <p>
                                                    <FontAwesomeIcon
                                                        icon={faCheck}
                                                        style={{
                                                            color: "var(--primary)",
                                                            marginRight: "10px",
                                                        }}
                                                    />
                                                    Loan Structuring & Advisory
                                                </p>
                                                <p>
                                                    <FontAwesomeIcon
                                                        icon={faCheck}
                                                        style={{
                                                            color: "var(--primary)",
                                                            marginRight: "10px",
                                                        }}
                                                    />
                                                    Financial Compliance Guidance
                                                </p>
                                                <a
                                                    href="#"
                                                    className="btn py-2 px-4 mt-3"
                                                    style={{
                                                        backgroundColor: "var(--primary)",
                                                        color: "var(--white)",
                                                        border: "none",
                                                        borderRadius: "6px",
                                                        fontWeight: "500",
                                                        transition: "all 0.3s ease",
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                            "var(--secondary)";
                                                        e.currentTarget.style.color = "var(--dark)";
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                            "var(--primary)";
                                                        e.currentTarget.style.color = "var(--white)";
                                                    }}
                                                >
                                                    Learn More
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                        </div>

                    </div>
                </div>
                <section className="container py-5">
                    <div className="row text-center mb-4">
                        <h2>Retirement Planning</h2>
                        <p>Plan with Wisdom, Retire in Freedom</p>
                    </div>


                    <div className="row g-4 align-items-center">
                        <div className="col-md-4 text-center">
                            <img
                                src={retirment}
                                alt="Retirement Savings"
                                className="img-fluid rounded shadow"
                            />
                            <p className="mt-3 fw-semibold">Savings Today, Smiles Tomorrow</p>
                        </div>

                        <div className="col-md-4 text-center">
                            <img
                                src={retirment1}
                                alt="Secure Future"
                                className="img-fluid rounded shadow"
                            />
                            <p className="mt-3 fw-semibold">Your Path to a Carefree Tomorrow</p>
                        </div>

                        <div className="col-md-4 text-center">
                            <img
                                src={retirment2}
                                alt="Wisdom Plan"
                                className="img-fluid rounded shadow"
                            />
                            <p className="mt-3 fw-semibold">Plan with Confidence</p>
                        </div>
                    </div>
                </section>
                <section className="container py-5">
                    <div className="row text-center mb-4">
                        <h2>Education planning </h2>
                        <p>Let Your Child's DREAM take a FLIGHT !</p>
                    </div>


                    <div className="row g-4 align-items-center">
                        <div className="col-md-4 text-center">
                            <img
                                src={study}
                                alt="Retirement Savings"
                                className="img-fluid rounded shadow"
                            />
                            <p className="mt-3 fw-semibold">Plan today for a brighter tomorrow.</p>
                        </div>

                        <div className="col-md-4 text-center">
                            <img
                                src={study1}
                                alt="Secure Future"
                                className="img-fluid rounded shadow"
                            />
                            <p className="mt-3 fw-semibold"> Invest in your child's future.</p>
                        </div>

                        <div className="col-md-4 text-center">
                            <img
                                src={study2}
                                alt="Wisdom Plan"
                                className="img-fluid rounded shadow"
                            />
                            <p className="mt-3 fw-semibold">An investment in knowledge pays the best interest. </p>
                        </div>
                    </div>
                </section>
                <section className="container py-5">
                    <div className="row text-center mb-4">
                        <h2>Financial Planning</h2>
                        <p>Building Right Financial Portfolio For You !</p>
                    </div>


                    <div className="row g-4 align-items-center">
                        <div className="col-md-4 text-center">
                            <img
                                src={FINANCIAL1}
                                alt="Retirement Savings"
                                className="img-fluid rounded shadow"
                            />
                            <p className="mt-3 fw-semibold">We are into Wealth Management </p>
                        </div>

                        <div className="col-md-4 text-center">
                            <img
                                src={FINANCIAL}
                                alt="Secure Future"
                                className="img-fluid rounded shadow"
                            />
                            <p className="mt-3 fw-semibold">Smart Financial Planning for Joyful Happy Families👆</p>
                        </div>

                        <div className="col-md-4 text-center">
                            <img
                                src={FINANCIAL2}
                                alt="Wisdom Plan"
                                className="img-fluid rounded shadow"
                            />
                            <p className="mt-3 fw-semibold">From Goals to Growth to Great Family Life.</p>
                        </div>
                    </div>
                </section>
            </section>

            <section
                className="container-fluid callback my-5 pt-5 position-relative"
                style={{ overflow: "hidden" }}
            >
                {/* ✅ Background layer replacing ::before */}
                <div
                    style={{
                        position: "absolute",
                        content: '""',
                        width: "100%",
                        height: "50%",
                        top: 0,
                        left: 0,
                        zIndex: -1,
                        background: `linear-gradient(rgba(0,119,125,0.95), rgba(0,119,125,0.95)), url(${bgImage})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                    }}
                ></div>

                <div className="container pt-5">
                    <div className="row justify-content-center">
                        <div className="col-lg-7">
                            <div
                                className="bg-white border rounded p-4 p-sm-5 shadow-sm"
                                style={{
                                    borderColor: "var(--secondary)",
                                    backgroundColor: "var(--white)",
                                }}
                            >
                                {/* Header */}
                                <div
                                    className="text-center mx-auto mb-4"
                                    style={{ maxWidth: "600px" }}
                                >
                                    <p
                                        className="d-inline-block border rounded fw-semi-bold py-1 px-3"
                                        style={{
                                            color: "var(--primary)",
                                            borderColor: "var(--primary)",
                                            backgroundColor: "var(--white)",
                                        }}
                                    >
                                        Get In Touch
                                    </p>
                                    <h1
                                        className="display-5 mb-4"
                                        style={{ color: "var(--heading)", fontWeight: "700" }}
                                    >
                                        Request A Call-Back
                                    </h1>
                                </div>

                                {/* Form */}
                                <form onSubmit={handleSubmit}>
                                    <div className="row g-3">
                                        <div className="col-sm-6">
                                            <div className="form-floating">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="name"
                                                    placeholder="Your Name"
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                    required
                                                    style={{
                                                        borderColor: "var(--secondary)",
                                                        color: "var(--dark)",
                                                    }}
                                                />
                                                <label htmlFor="name" style={{ color: "var(--text)" }}>
                                                    Your Name
                                                </label>
                                            </div>
                                        </div>

                                        <div className="col-sm-6">
                                            <div className="form-floating">
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    id="email"
                                                    placeholder="Your Email"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    required
                                                    style={{
                                                        borderColor: "var(--secondary)",
                                                        color: "var(--dark)",
                                                    }}
                                                />
                                                <label htmlFor="email" style={{ color: "var(--text)" }}>
                                                    Your Email
                                                </label>
                                            </div>
                                        </div>

                                        <div className="col-sm-6">
                                            <div className="form-floating">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="mobile"
                                                    placeholder="Your Mobile"
                                                    value={formData.mobile}
                                                    onChange={handleChange}
                                                    style={{
                                                        borderColor: "var(--secondary)",
                                                        color: "var(--dark)",
                                                    }}
                                                />
                                                <label htmlFor="mobile" style={{ color: "var(--text)" }}>
                                                    Your Mobile
                                                </label>
                                            </div>
                                        </div>

                                        <div className="col-sm-6">
                                            <div className="form-floating">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="subjects"
                                                    placeholder="Subject"
                                                    value={formData.subjects}
                                                    onChange={handleChange}
                                                    style={{
                                                        borderColor: "var(--secondary)",
                                                        color: "var(--dark)",
                                                    }}
                                                />
                                                <label htmlFor="subject" style={{ color: "var(--text)" }}>
                                                    Subject
                                                </label>
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            <div className="form-floating">
                                                <textarea
                                                    className="form-control"
                                                    id="message"
                                                    placeholder="Leave a message here"
                                                    style={{
                                                        height: "100px",
                                                        borderColor: "var(--secondary)",
                                                        color: "var(--dark)",
                                                    }}
                                                    value={formData.message}
                                                    onChange={handleChange}
                                                />
                                                <label htmlFor="message" style={{ color: "var(--text)" }}>
                                                    Message
                                                </label>
                                            </div>
                                        </div>

                                        <div className="col-12 text-center">
                                            <button
                                                className="btn w-100 py-3"
                                                type="submit"
                                                style={{
                                                    backgroundColor: "var(--primary)",
                                                    color: "var(--white)",
                                                    border: "none",
                                                    borderRadius: "6px",
                                                    fontWeight: "500",
                                                    transition: "all 0.3s ease",
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor = "var(--secondary)";
                                                    e.currentTarget.style.color = "var(--dark)";
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor = "var(--primary)";
                                                    e.currentTarget.style.color = "var(--white)";
                                                }}
                                            >
                                                Submit Now
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="container-xxl py-5 d-none" style={{ backgroundColor: "var(--light-bg)" }}>
                <div className="container">
                    <div
                        className="text-center mx-auto"
                        style={{ maxWidth: "600px" }}
                    >
                        <p
                            className="d-inline-block border rounded fw-semi-bold py-1 px-3"
                            style={{
                                color: "var(--primary)",
                                borderColor: "var(--primary)",
                                backgroundColor: "var(--white)",
                            }}
                        >
                            Our Projects
                        </p>
                        <h1
                            className="display-5 mb-5"
                            style={{ color: "var(--heading)", fontWeight: "700" }}
                        >
                            We Have Completed Latest Projects
                        </h1>
                    </div>

                    {/* ✅ React Multi Carousel */}
                    <Carousel
                        responsive={responsive}
                        infinite={true}
                        autoPlay={true}
                        autoPlaySpeed={3000}
                        showDots={true}
                        arrows={false}
                        className="project-carousel"
                    >
                        {projects.map((project, i) => (
                            <div key={i} className="project-item pe-4 pb-5">
                                <div
                                    className="project-img mb-3 position-relative"
                                    style={{
                                        border: "4px solid var(--secondary)",
                                        borderRadius: "10px",
                                        overflow: "hidden",
                                        transition: "transform 0.4s ease, box-shadow 0.4s ease",
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = "translateY(-6px)";
                                        e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.15)";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = "translateY(0)";
                                        e.currentTarget.style.boxShadow = "none";
                                    }}
                                >
                                    <img
                                        className="img-fluid rounded w-100"
                                        src={project.img}
                                        alt={project.title}
                                        style={{ objectFit: "cover" }}
                                    />
                                    <a
                                        href="#"
                                        className="project-link d-flex justify-content-center align-items-center"
                                        style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            background: "rgba(0,119,125,0.7)",
                                            opacity: 0,
                                            transition: "opacity 0.4s ease",
                                        }}
                                        onMouseEnter={(e) => (e.currentTarget.style.opacity = "1")}
                                        onMouseLeave={(e) => (e.currentTarget.style.opacity = "0")}
                                    >
                                        <FontAwesomeIcon
                                            icon={faLink}
                                            className="fa-3x"
                                            style={{ color: "var(--white)" }}
                                        />
                                    </a>
                                </div>
                                <div className="project-title text-center">
                                    <h4 className="mb-0" style={{ color: "var(--heading)" }}>
                                        {project.title}
                                    </h4>
                                </div>
                            </div>
                        ))}
                    </Carousel>
                </div>
            </section>



            <section
                className="container-xxl py-5"
                style={{ backgroundColor: "var(--light-bg)" }}
            >
                <div className="container">
                    <div
                        className="text-center mx-auto"
                        style={{ maxWidth: "600px" }}
                    >
                        <p
                            className="d-inline-block border rounded fw-semi-bold py-1 px-3"
                            style={{
                                color: "var(--primary)",
                                borderColor: "var(--primary)",
                                backgroundColor: "var(--white)",
                            }}
                        >
                            Testimonial
                        </p>
                        <h1
                            className="display-5 mb-5"
                            style={{ color: "var(--heading)", fontWeight: "700" }}
                        >
                            What Our Clients Say!
                        </h1>
                    </div>

                    <Carousel
                        responsive={responsive}
                        infinite={true}
                        autoPlay={true}
                        autoPlaySpeed={4000}
                        showDots={true}
                        arrows={false}
                        className="testimonial-carousel"
                    >
                        {testimonials.map((item, i) => (
                            <div
                                key={i}
                                className="testimonial-item text-center px-3 pb-5"
                                style={{ animation: "fadeInUp 0.8s ease", animationDelay: `${0.2 * i}s` }}
                            >
                                <div
                                    className="testimonial-text border rounded p-4 pt-5 mb-5 position-relative"
                                    style={{
                                        backgroundColor: "var(--white)",
                                        borderColor: "var(--secondary)",
                                        boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
                                        transition: "transform 0.4s ease, box-shadow 0.4s ease",
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = "translateY(-6px)";
                                        e.currentTarget.style.boxShadow = "0 8px 25px rgba(0,0,0,0.15)";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = "translateY(0)";
                                        e.currentTarget.style.boxShadow = "0 5px 15px rgba(0,0,0,0.1)";
                                    }}
                                >
                                    <div
                                        className="btn-square border rounded-circle position-absolute top-0 start-50 translate-middle"
                                        style={{
                                            backgroundColor: "var(--secondary)",
                                            width: "60px",
                                            height: "60px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <FontAwesomeIcon
                                            icon={faQuoteRight}
                                            className="fa-2x"
                                            style={{ color: "var(--white)" }}
                                        />
                                    </div>

                                    <p
                                        className="mt-3"
                                        style={{
                                            color: "var(--text)",
                                            fontStyle: "italic",
                                            lineHeight: "1.7",
                                        }}
                                    >
                                        {item.text}
                                    </p>
                                </div>

                                <img
                                    className="rounded-circle mb-3"
                                    src={item.img}
                                    alt={item.name}
                                    style={{
                                        width: "80px",
                                        height: "80px",
                                        objectFit: "cover",
                                        border: "3px solid var(--secondary)",
                                    }}
                                />
                                <h4
                                    className="mb-0"
                                    style={{ color: "var(--heading)", fontWeight: "600" }}
                                >
                                    {item.name}
                                </h4>
                                <span style={{ color: "var(--primary)" }}>{item.role}</span>
                            </div>
                        ))}
                    </Carousel>
                </div>
            </section>

        </div>

    );
};

export default Home;
